import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getToken } from "firebase/messaging";
import { db, getFirebaseMessagingSafe } from "../Firebase";

/* ---------------------------
   AUDIO
--------------------------- */

export function createAudio() {
  const audio = new Audio("/new-order.mp3");
  audio.preload = "auto";
  return audio;
}

export async function unlockAudio(audio) {
  if (!audio) return false;

  try {
    audio.currentTime = 0;
    await audio.play();
    audio.pause();
    audio.currentTime = 0;
    return true;
  } catch {
    return false;
  }
}

/* ---------------------------
   FIREBASE TOKEN
--------------------------- */

async function saveNotificationToken(token, restaurantId) {
  if (!token || !restaurantId) return;

  const ref = doc(db, "restaurants", restaurantId, "notificationTokens", token);

  await setDoc(
    ref,
    {
      token,
      platform: "web",
      origin: window.location.origin, // 🔥 AJOUT ICI
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function initPushNotifications(restaurantId) {

    console.log("PROJECT_ID", process.env.REACT_APP_PROJECT_ID);
console.log("API_KEY", process.env.REACT_APP_API_KEY);
console.log("SENDER_ID", process.env.REACT_APP_MESSAGING_SENDER_ID);
console.log("VAPID", process.env.REACT_APP_FIREBASE_VAPID_KEY);
    if (!("Notification" in window)) {
      return { success: false, reason: "not_supported" };
    }
  
    let permission = Notification.permission;
  
    if (permission !== "granted") {
      permission = await Notification.requestPermission();
    }
  
    if (permission !== "granted") {
      return { success: false, reason: "denied" };
    }
  
    const messaging = await getFirebaseMessagingSafe();
    if (!messaging) {
      return { success: false, reason: "no_messaging" };
    }
  
    // 🔥 IMPORTANT
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const registration = await navigator.serviceWorker.ready;
  
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
  
  
    if (token) {
      await saveNotificationToken(token, restaurantId);
    }
  
    return { success: true, token };
  }

/* ---------------------------
   ORDER SOUND LOGIC
--------------------------- */

export function shouldPlaySound(ordersList, previousMap) {
  let shouldPlay = false;

  for (const order of ordersList) {
    const prev = previousMap.get(order.id);

    if (prev === undefined && order.status === "paid") {
      shouldPlay = true;
      break;
    }

    if (prev !== "paid" && order.status === "paid") {
      shouldPlay = true;
      break;
    }
  }

  return shouldPlay;
}

export function buildOrderStatusMap(ordersList) {
  return new Map(ordersList.map((o) => [o.id, o.status]));
}